import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class NotepadOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.NOTEPAD)) {
      provider.addDeliveryOption(new DeliveryOption(DeliveryOptionConstants.NOTEPAD));
    }
  }
}

export default NotepadOptionHandler;
